import { Button } from "components/Atoms/Button";
import { SearchInput } from "components/Atoms/SearchInput";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import Modal from "components/modal";
import React from "react";
import { Message } from "components/Atoms/Message";
import { newLineToBr } from "utilities/newlinetobr";
import BusinessCentralCustomer from "./BusinessCentralCustomer";
import { useBusinessCentralCustomer, useMutateBusinessCentralCustomerLink } from "./hooks";
import { useDebounce } from "utilities/usehooks";

interface Props {
  companyId: number
  isLinkModalOpen: boolean
  handleLinkModalClose: () => void
  onLinked: (businessCentralNumber: string) => void
}

const LinkBusinessCentralCustomer = (props: Props) => {
  const [businessCentralNumber, setBusinessCentralNumber] = React.useState(undefined);
  const debouncedBusinessCentralNumber = useDebounce(businessCentralNumber);

  const businessCentralDetails = useBusinessCentralCustomer(debouncedBusinessCentralNumber, {
    enabled: Boolean(businessCentralNumber)
  });

  const mutate = useMutateBusinessCentralCustomerLink();

  const hasBusinessCentralData = businessCentralDetails.data?.data != null;

  const hasErrorsFetching = businessCentralDetails.data != null && businessCentralDetails.data.errors.length > 0;

  const hasErrorsSaving = mutate.data != null && mutate.data.data.hasErrors;

  const apiCallFailed = businessCentralDetails.isError || mutate.isError;

  const onSave = async () => {
    const res = await mutate.mutateAsync({ companyId: props.companyId, businessCentralNumber });
    if (!res.data.hasErrors) {
      props.onLinked(businessCentralNumber);
    }
  };

  return <Modal
    isOpen={props.isLinkModalOpen}
    handleClose={props.handleLinkModalClose}
    title={"Business Central"}
    width="tiny"
    minHeight={300}
  >
    <SearchInput
      onChange={value => { setBusinessCentralNumber(value); }}
      value={businessCentralNumber || ""}
      placeholder={RESX.BusinessCentral.FindCustomerByNumber}
      maxLength={serverReference.constants.company.maxBusinessCentralNumberLength}
    />

    {apiCallFailed && <SomethingUnexpectedHappenedMessageBox />}

    {hasErrorsFetching && <Message type="error">
      {newLineToBr(businessCentralDetails.data.errors.map(e => e.message).join("\n"))}
    </Message>}

    {hasErrorsSaving && <Message type="error">
      {newLineToBr(mutate.data.data.errors.map(e => e.message).join("\n"))}
    </Message>}

    {hasBusinessCentralData && <>
      <div className="grow1 gray-100 padding-large">
        <BusinessCentralCustomer customer={businessCentralDetails.data.data} />
      </div>

      <div className="flex">
        <div className="grow1"></div>
        <div>
          <Button type="primary" label={RESX.Buttons.btnSave} onClick={onSave} loading={mutate.isLoading} disabled={mutate.isLoading} />
        </div>
      </div>
    </>}
  </Modal>;
};

export default LinkBusinessCentralCustomer;